export default "__VITE_ASSET__ZP3jC0M0__"